import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { PesquisaHomeOffice } from './../models/pesquisa-home-office';
import { PesquisaHomeOfficeService } from './../services/pesquisa-home-office.service';

@Component({
  selector: 'app-pesquisahomeoffice',
  templateUrl: './pesquisahomeoffice.component.html',
  styleUrls: ['./pesquisahomeoffice.component.css']
})


export class PesquisahomeofficeComponent implements OnInit {
  
  // Form pesquisa home Office
  pesquisaForm = new FormGroup({
    nivelProdutividade: new FormControl('0'),
    nivelEnvolvimento: new FormControl('0'),
    nivelRecursos: new FormControl('0'),
    nivelAdocaoFutura: new FormControl('0'),
    nivelExperiencia: new FormControl('0')
  });

  pesquisa = {} as PesquisaHomeOffice;
  pesquisas: PesquisaHomeOffice[];
  
  constructor(private pesquisaService: PesquisaHomeOfficeService) {}

  exibirAlerta: boolean;
  mensagemResposta: string;
  mensagemRespostaDetalhe: string;

  ngOnInit() {
    this.exibirAlerta = false;
    this.mensagemResposta = "";
    this.mensagemRespostaDetalhe = "";
  }

  // Chama o serviço para obtém todos as pesquisas
  getPesquisas() {
    this.pesquisaService.getPesquisaHomeOffice().subscribe((pesquisas: PesquisaHomeOffice[]) => {
      this.pesquisas = pesquisas;
    });
  }

  onSubmit() {
    var pesquisaform = this.pesquisaForm.value as PesquisaHomeOffice;
    this.pesquisaService.savePesquisaHomeOffice(pesquisaform).subscribe((pesquisas: PesquisaHomeOffice) => {
      this.formEnviado(true, "Enviado com Sucesso!", "Obrigado por participar da pesquisa, assim que acabar o isolamento social causado pela pandemia o resultado será disponibilizado neste mesmo canal");
      console.warn(pesquisas);
    },
    (err) => {
      this.formEnviado(true, "Ocorreu algo inesperado, tente mais tarde por favor", err);
      console.warn(err);
    });
  }

  formEnviado(exibirMensagem: boolean, titulo: string, mensagem: string) {
    this.exibirAlerta = exibirMensagem;
    this.mensagemResposta = titulo;
    this.mensagemRespostaDetalhe = mensagem;
  }
}
